:host {
  display: block;
}

.btn-outline-light {
    border-color: #D4DAE0;
}

.font-weight-regular {
    font-family: "noto-sans-regular";
}
